import * as Actions from './constants';

const getStoredCart = () => {
  try {
    const stored = localStorage.getItem('cartItems');
    return stored ? JSON.parse(stored) : [];
  } catch (err) {
    return [];
  }
};

const initState = {
  items: getStoredCart(),
  isDrawerOpen: false,
};

export default function cartReducer(state = initState, action = {}) {
  switch (action.type) {
    case Actions.CART_ADD_ITEM: {
      const { product, quantity, openDrawer = true } = action.payload;
      const existingIndex = state.items.findIndex(item => item.product.id === product.id);
      let updatedItems;

      if (existingIndex > -1) {
        updatedItems = [...state.items];
        updatedItems[existingIndex] = {
          ...updatedItems[existingIndex],
          quantity: updatedItems[existingIndex].quantity + quantity,
        };
      } else {
        updatedItems = [...state.items, { product, quantity }];
      }

      return {
        ...state,
        items: updatedItems,
        isDrawerOpen: openDrawer,
      };
    }

    case Actions.CART_REMOVE_ITEM: {
      const productId = action.payload;
      const updatedItems = state.items.filter(item => item.product.id !== productId);
      return {
        ...state,
        items: updatedItems,
      };
    }

    case Actions.CART_UPDATE_QUANTITY: {
      const { productId, quantity } = action.payload;
      let updatedItems;

      if (quantity <= 0) {
        updatedItems = state.items.filter(item => item.product.id !== productId);
      } else {
        updatedItems = state.items.map(item =>
          item.product.id === productId ? { ...item, quantity } : item
        );
      }

      return {
        ...state,
        items: updatedItems,
      };
    }

    case Actions.CART_CLEAR: {
      return {
        ...state,
        items: [],
      };
    }

    case Actions.CART_TOGGLE_DRAWER: {
      return {
        ...state,
        isDrawerOpen: action.payload !== undefined ? action.payload : !state.isDrawerOpen,
      };
    }

    default:
      return state;
  }
}
